/*  韩文包  */
import koLocale from 'element-ui/lib/locale/lang/ko';
const hy = {
    message: {
        /*  导航栏语言设定 */
        'headerMenu' : '네트워크 디스크',
        'headerlangSelect' : '언어를 선택하십시오',
        'headerLoginOut' : '로그 아웃',

        /*  侧边栏语言设定 */
        'sideMenuFileName' : '모든 파일',
        'sideMenuPhoto' : '사진',
        'sideMunsDoc' : '파일',
        'sideMenuVideo' : '비디오',
        'sideMenuSeed' : '종자',
        'sideMenuMusic' : '음악',
        'sideMenuOrther' : '기타',
        'sideMenuShareName' : '내 몫',
        'sideMenuCollectName' : '휴지통',

        /*  用户语言设定 */
        'mainUpload' : '업로드',
        'mainBuildDir' : '새 폴더',
        'mainDownloadOutline' : '오프라인으로 다운로드',
        'mainSearch' : '파일 검색',
        'mainAllFile' : '모든 파일',
        'mainFile' : '파일',
        'mainSize' : '사이즈',
        'mainDate' : '날짜',
        'mainFileDel' : '삭제',
        'mainConfirmDel' : '삭제 확인?',
        'sure' : '확인',
        'cancel' : '취소',
        'mainReturn' : '돌아 가기',
        'mainPagePrev' : '이전',
        'mainPageNext' : '다음 페이지',
        'mainLoaded' : '로드',
        'mainTotal' : '총계',
        'mainUnit' : '스트립',
        'dilatation' : '확장',
        /*  回收站设定  */
        'mainHeaderTitle' : '팁 : 휴지통은 네트워크 디스크 공간을 차지하지 않습니다.',
        'mainHeaderButton' : '빈 휴지통',
        'collectName' : '휴지통',
        'mainRevertIts' : '복원',
        'mianDelData' : '시간 삭제',

        'confirmClear' : '선택한 파일을 지우시겠습니까? (클리어 후 복구 할 수 없음)',
        'confirmClearAll' : '휴지통을 비우시겠습니까?',

        /*  其他设定 */
        'messageBoxTitle' : '힌트',
        'messageBoxConfirmRevert' : '선택한 파일을 복원 하시겠습니까?',
        'loading' : '로딩 중 ...',
        'loaded' : '데이터가 없습니다',

        'messageMoveTo' : '로 이동',
        'filterNotice' : '필터링 할 키워드를 입력하십시오',
        'messageLoaded' : '다운로드 :',
        'messageMovetion' : '파일 이동',

        'messageMissKeyWord' : '검색 키워드를 입력하십시오',
        'messageFolderLayersLimit' : '작성 실패 폴더 계층 구조 깊이가 5 레벨을 초과하지 않습니다',
        'messageSameFolderName' : '생성 실패 동일한 파일 이름이 존재합니다',
        'messageEmptyFolderName' : '폴더 이름을 입력하십시오',
        'messageMoveSame' : '같은 폴더로 이동할 수 없습니다',
        'messageActionError' : '작업 실패',
        'messageActionSuccess' : '작업 성공',
        'messageServerIsBusy' : '서버 사용량이 많음',
        'messageUploadOverLimit' : '너무 많은 파일이 선택되었습니다 (5 이내)',
        'messageDiskFreeFull' : '사용자 공간이 부족합니다',
        'messageUploadTypeError' : '이 형식의 파일을 업로드 할 수 없습니다',
        'messageUploadMaxSize' : '업로드 파일이 너무 큽니다 (10M 이내).',
        'messageUploadSuccess' : '성공적으로 업로드되었습니다',
        'messageUploadFailed' : '업로드 실패',
        'messageDownloadFailed' : '다운로드 실패'
    },
    ...koLocale
};

export default hy;



// WEBPACK FOOTER //
// ./src/i18n/langs/hy.js